export default __webpack_public_path__ + "images/9faa996305d7342e7b7858abe59e5f0a-adoption-dog-669.gif";